export enum ProviderEnum {
	Metamask = 'metamask',
	Walletconnect = 'walletconnect',
	Coinbase = 'coinbase'
}
